module.exports = __webpack_public_path__ + "static/media/icon-default-logo.a60fdc32.png";